<template >
  <div class="new-life">
    <my-scroll class="scroll">
      <div class="scroll-content">
        <header>ສັນຍາການບໍລິການຂອງ GoLaos</header>
        <div class="letter"
             style="text-indent:2em">
          ແພຣດຟອມການບໍລິການຂອງ GoLaos ຈະສະໜອງການບໍລິການໃຫ້ທຸກທ່ານພາຍໃຕ້ເງື່ອນໄຂ ແລະ ຂໍ້ກໍານົດຄືດັ່ງລຸ່ມນີ້, ກະລຸນາໃຫ້ອ່ານລະອຽດ ແລະ ປະຕິບັດຕາມເງື່ອນໄຂ ແລະ ຂໍ້ກໍານົດຢ່າງເຂັມງວດ.
        </div>
        <h3>ມາດຕາ 01 : ບົດບັນຍັດທົ່ວໄປ</h3>
        <div class="letter">
          1.ສັນຍາການບໍລິການຂອງ GoLaos ສະບັບນີ້ ( ຕໍ່ໄປນີ້ເອີ້ນຫຍໍ້ວ່າ “ສັນຍາ” ) ເຮັດຂຶ້ນລະຫວ່າງ ຜູ້ນໍາໃຊ້(ຮ້ານຄ້າ) ແລະ ບໍລິສັດ GoLaos ກ່ຽວກັບການບໍລິການຂອງ GoLaos.ທາງບໍລີສັດGoLaos ແຈ້ງໃຫ້ທຸກທ່ານທີ່ນໍາໃຊ້ບໍລິການໃຫ້ອ່ານ ແລະ ເຂົ້າໃຈຂໍ້ຕົກລົງຂອງສັນຍາໃຫ້ລະອຽດ. ໂດຍສະເພາະແມ່ນຂໍ້ທີ່ກ່ຽວກັບການຍົກເວັ້ນ ຫຼື ຈຳກັດຄວາມຮັບຜິດຊອບຂອງ GoLaos, ຂໍ້ກໍານົດທີ່ຈຳກັດສິດ ແລະ ພັນທະຂອງຮ້ານຄ້າ, ການນໍາໃຊ້ກົດໝາຍ ແລະ ຂໍ້ກຳນົດໃນການແກ້ໄຂຂໍ້ຂັດແຍ້ງຕ່າງໆ.
        </div>
        <div class="letter1 letter">
          2.ກະລຸນາອ່ານເນື້ອໃນຂອງສັນຍາຢ່າງລະອຽດກ່ອນ,ແລ້ວເລືອກ “ຕົກລົງເຫັນດີ” ຫຼື “ບໍໍ່ເຫັນດີ” , ທ່ານຕ້ອງຮັບຮອງຂໍ້ກໍານົດທັງໝົດຂອງສັນຍາສະບັບນີ້ກ່ອນ ຈິ່ງສາມາດນໍາໃຊ້ບໍລິການພາຍໃຕ້ສັນຍາໄດ້, ຖ້າບໍ່ດັ່ງນັ້ນ, ທ່ານຈະບໍ່ມີສິດນໍາໃຊ້ບໍລິການຂອງພວກເຮົາ. ການກະທໍາທີ່ກ່ຽວກັບການລົງທະບຽນ, ການນໍາໃຊ້, ການໄດ້ຮັບບັນຊີ ແລະ ການເຂົ້າສູ່ລະບົບຂອງທ່ານໝາຍເຖິງທ່ານໄດ້ຍອມຮັບ ແລະ ຕົກລົງເຫັນດີຕາມຂໍ້ກໍານົດທຸກຂໍ້ ແລະ ເນື້ອໃນທັງໝົດຂອງສັນຍາສະບັບນີ້, ທ່ານບໍ່ສາມາດຮຽກຮ້ອງສິດໃດໆ ຫຼື ສະເໜີຮ້ອງທຸກໂດຍເຫດຜົນໃດໆ ລວມທັງເຫດຜົນທີ່ອ້າງວ່າ ບໍ່ໄດ້ອ່ານ ແລະ ບໍ່ທັນເຂົ້າໃຈເນື້ອໃນຂອງສັນຍາສະບັບນີ້.
        </div>
        <div class="letter1 letter">
          3.ສັນຍາສະບັບນີ້ທາງ GoLaos ສາມາດປັບປຸງໄດ້ໃນທຸກເວລາ, GoLaos ຈະເຜີຍແຜ່ສະບັບລ່າສຸດຂໍ້ກໍານົດລ້າສຸດຂອງຂໍ້ຕົກລົງຢູ່ໃນເວັບໄຊ ຫຼື ໃນແພຣດຟອມຂອງ GoLaos, ຂໍ້ຕົກລົງທີ່ໄດ້ປັບປຸງໃໝ່ນັ້ນມີຜົນບັງຄັບໃຊ້ຫຼັງ 24 ຊົ່ວໂມງ ນັບແຕ່ເວລາໄດ້ເຜີຍແຜ່ລົງເປັນຕົ້ນໄປ. ຖ້າຫາກທ່ານໃດບໍ່ເຫັນດີກັບຂໍ້ກຳນົດທີ່ຖືກປັບປຸງໃໝ່ນັ້ນ, ທ່ານສາມາດຕິດຕໍ່ຫາສູນບໍລິການຂອງ GoLaos ພາຍໃນ 24 ຊົ່ວໂມງນັບແຕ່ເວລາລົງເຜີຍແຜ່ເປັນຕົ້ນໄປ ຫຼື ທ່ານສາມາດຢຸດຕິການນໍາໃຊ້ບໍລິການຂອງ GoLaos ໄດ້ທັນທີ, ຖ້າຫາກທ່ານບໍ່ໄດ້ຕິດຕໍ່ຫາສູນບໍລິການພາຍໃນ 24 ຊົ່ວໂມງ ຫຼື ພາຍຫຼັງໄດ້ມີການປັບປຸງສັນຍາສຳເລັດແລ້ວທ່ານຍັງສືບຕໍ່ນໍາໃຊ້ການບໍລິການຂອງ GoLaos ຢູ່, ຖືວ່າທ່ານຍອມຮັບ ແລະ ຕົກລົງເຫັນດີເນື້ອໃນທັງໝົດທີ່ໄດ້ຖືກປັບປຸງໃໝ່.
        </div>
        <h3>ມາດຕາ 02 : ຄໍານິຍາມ</h3>
        <div class="letter1 letter">
          1.ແພຣດຟອມ GoLaos : ເເມ່ນ ແພຣດຟອມສຳລັບການກໍ່ສ້າງ, ສະໜອງ ແລະ ຮັກສາ ການຂາຍຜະລິດຕະພັນ ແລະ ການໃຫ້ຂໍ້ມູນກ່ຽວກັບການຂາຍສີນຄ້າໂດຍຜ່ານອິນເຕີເນັດແບບການຂາຍonline, ຜູ້ນໍາໃຊ້ ແລະ ຮ້ານຄ້າຕ້ອງໄດ້ບັນລຸຂໍ້ຕົກລົງກ່ຽວກັບການຂາຍຜະລິດຕະພັນ ແລະ ການບໍລິການ ດ້ານກີນດື່ມ ໂດຍຜ່ານ ແພຣດຟອມ GoLaos.
        </div>
        <div class="letter1 letter">
          2.ຜູ້ນໍາໃຊ້: ໝາຍເຖິງບຸກຄົນທີ່ມີສິດ ແລະ ຄວາມສາມາດເຕັມທີ່ ສຳລັບພຶດຕິກຳ ທີ່ເຜີຍແຜ່ຂໍ້ມູນກ່ຽວກັບການຊື້ສີນຄ້າ ແລະ ຂາຍສິນຄ້າ, ການບໍລິການດ້ານກີນດື່ມ ແລະ ຄວາມຕ້ອງການອື່ນໆໃນແພຣດຟອມ GoLaos.
        </div>
        <div class="letter1 letter">
          3.ຮ້ານຄ້າ: ໝາຍເຖິງ“ທ່ານ” ທີ່ໄດ້ກໍານົດໄວ້ໃນສັນຍາສະບັບນີ້, ເຊິ່ງເປັນບຸກຄົນທີ່ຖືກຕ້ອງຕາມກົດໝາຍ ແລະ ມີຢູ່ຢ່າງຖືກຕ້ອງຕາມກົດໝາຍລາວ ຫຼື ມີສ່ວນຮ່ວມໃນການຂາຍສີນຄ້າ ແລະ ໄດ້ເລືອກນໍາໃຊ້ແພຣດຟອມ GoLaos ດ້ວຍຕົນເອງ ເພື່ອເຜີຍແຜ່ຂໍ້ມູນທີ່ກ່ຽວກັບການຄ້າຂາຍ, ການບໍລິການກີນດື່ມ ແລະ ຄວາມຕ້ອງການອື່ນ.
        </div>
        <h3>ມາດຕາ 03 : ສິດ ແລະ ພັນທະຂອງຮ້ານຄ້າ</h3>
        <div class="letter letter1">
          1.ຮ້ານຄ້າຕ້ອງຮັບປະກັນວ່າຕົນເອງແມ່ນຖືກຕ້ອງຕາມກົດໝາຍຂອງ ສປປ ລາວ ແລະ ມີສິດດໍາເນີນທຸລະກິດຢ່າງຖືກຕ້ອງ ຫຼື ມີຫົວໜ່ວຍທຸລະກິດທີ່ດໍາເນີນທຸລະກິດກ່ຽວກັບການຄ້າຂາຍ, ການບໍລິການກີນດື່ມ ແລະ ຮູບແບບອື່ນໆນັ້ນ, ສາມາດຮັບຜິດຊອບຕໍ່ໜ້າທີ່ກົດໝາຍ ແລະ ມິສິດ ຫຼື ຄວາມສາມາດປະຕິບັດສັນຍາສະບັບນີ້ໄດ້, ທາງຮ້ານຄ້າຕ້ອງສະໜອງບັນດາເອກະສານ ຫຼື ທະບຽນທີ່ກ່ຽວຂ້ອງໂດຍຈໍ້າກາໃສ່ສະບັບສໍາເນົາ, ຖ້າຫາກເປັນກິດຈະການທີ່ຄວບຄຸມ ຫຼື ກິດຈະການທີ່ກໍານົດເປັນພິເສດຕ້ອງສະໜອງໃບອະນຸຍາດດໍາເນີນທຸລະກິດຕ່າງໆ; ບັນດາເອກະສານທີ່ຕ້ອງສະໜອງລວມທັງບໍ່ຈໍາກັດສະເພາະແຕ່: ໃບທະບຽນວິສາຫະກິດ, ໃບອະນຸຍາດດໍາເນີນທຸລະກິດ, ຄໍາອະທິບາຍກ່ຽວກັບສິນຄ້າທີ່ຂາຍ , ຂໍ້ມູນໃນໜ້າຫຼັກ ແລະ ຂໍ້ມູນສ່ວນຕົວທີ່ຈໍາເປັນຄື: ໃບ
          ຢັ້ງຢືນທີ່ຢູ່, ສໍາເນົາບັດປະຈໍາຕົວ, ໜັງສືຜ່ານແດນ, ສໍາມະໂນຄົວ(ລວມທັງຮູບຖ່າຍ ແລະ ໂປເຈັກຂອງຮ້ານຄ້າ)ຕ່າງໆ. ຮ້ານຄ້າຕ້ອງຮັບປະກັນວ່າເອກະສານທັງໝົດທີ່ສະໜອງໃຫ້ແມ່ນຖືກຕ້ອງຕາມກົດໝາຍ ແລະ ມີປະສິດທິພາບ, ບໍ່ລ່ວງລະເມີດສິດທີ່ແລະ ຜົນປະໂຫຍດອັນຊອບທຳຂອງບຸກຄົນທີ່ສາມ, ຖ້າຫາກຍ້ອນຂໍ້ມູນບໍ່ຖືກຕ້ອງ ຫຼື ປອມແປງເອກະສານເຮັດໃຫ້ມີຜົນເສຍຫາຍນັ້ນ, ທາງຮ້ານຄ້າຕ້ອງຮັບຜິດຊອບຕໍ່ຜົນເສຍຫາຍທັງໝົດທີ່ເກີດຂຶ້ນ. ຖ້າຫາກຊື່ຂອງຮ້ານຄ້າ, ທີ່ຢູ່ ແລະ ເບີີຕິດຕໍ່ ຫຼື ຂໍ້ມູນໃນທະບຽນມີການປ່ຽນແປງ, ຮ້ານຄ້າຕ້ອງແຈ້ງໃຫ້ GoLaos ຮັບຊາບເປັນລາຍລັກອັກສອນ ຫຼື ແຈ້ງຜ່ານອິເມວ. ຖ້າຫາກທາງຮ້ານຄ້າບໍ່ແຈ້ງໃຫ້ຊາບຕາມເວລາທີ່ກໍານົດ, ເຮັດໃຫ້ມີຜົນເສຍຕໍ່ຮ້ານຄ້າ ຫຼື GoLaos ນັ້ນ, ຮ້ານຄ້າຕ້ອງເປັນຝ່າຍຮັບຜິດຊອບຄວາມເສຍຫາຍທັງໝົດທີ່ເກີດຂຶ້ນ.
        </div>
        <div class="letter letter1">
          2.ທາງຮ້ານຄ້າຕ້ອງສະໜອງຂໍ້ມູນລະອຽດ ແລະ ຄໍາແນະນໍາຕ່າງໆຂອງສິນຄ້າ. ຮ້ານຄ້າຕ້ອງຮັບປະກັນວ່າຕົນເອງໄດ້ຮັບອະນຸຍາດດໍາເນີນທຸລະກິດການຄ້າຢ່າງຖືກຕ້ອງ,ສາມາດປະຕິບັດຕາມຂໍ້ກໍານົດ, ກົດລະບຽບຕ່າງໆຂອງສັນຍາສະບັບນີ້ໄດ້ ແລະ ມີບຸກຄະລະກອນ ຫຼື ມີເງື່ອນໄຂອື່ນຄົບຕາມຂໍ້ກໍານົດຂອງສັນຍາສະບັບນີ້. ຄຸນນະພາບຂອງສິນຄ້າທີ່ສົ່ງໃຫ້ GoLaos ຖືກຕ້ອງຕາມຄໍາອະທິບາຍຢູ່ໜ້າຫຼັກ ແລະ ມີຄຸນນະພາບ.
        </div>
        <div class="letter letter1">
          3.ສິນຄ້າທີ່ສົ່ງໃຫ້ນັ້ນ, ຮ້ານຄ້າຕ້ອງໄດ້ມາດຕະຖານ ແລະ ຖືກຕ້ອງຕາມລະບຽບກົດໝາຍຂອງລັດ. ຖ້າຜູ້ໃຊ້ບໍລິການຮ້ອງທຸກ ຫຼື ການຮຽກຮ້ອງ ການສູນເສຍທາງເສດຖະກິດ ແລະ ຜົນກະທົບອື່ນໆທີ່ກ່ຽວຂ້ອງເນື່ອງຈາກ ບັນຫາດ້ານຄຸນນະພາບ ຫຼື ຄວາມປອດໄພຂອງສີນຄ້າ, ທາງຮ້ານຄ້າຕ້ອງເປັນຮັບຜິດຊອບຄ່າເສຍຫາຍທັງໝົດ,ອີງຕາມສະຖານະການທີ່ກ່າວມາຂ້າງເທິງນັ້ນ ຖ້າ GoLaos ຕ້ອງໄດ້ທົດແທນຄ່າເສຍຫາຍໃຫ້ຜູ້ໃຊ້ບໍລິການກ່ອນ, ແຕ່ GoLaos ມີສິດຮຽກຮ້ອງໃຫ້ທາງຮ້ານຄ້າຈ່າຍຄືນໃຫ້,ວິທີການຮຽກຮ້ອງໃຫ້ຈ່າຍຄືນນັ້ນລວມທັງ ບໍ່ໄດ້ຈໍາກັດສະເພາະແຕ່ຈະຫັກຈໍານວນເງີນຊົດເຊີຍໂດຍຕົງ ທີ່ໄດ້ຕ້ອງຈ່າຍໃຫ້ຮ້ານຄ້ານັ້ນ.
        </div>
        <div class="letter letter1">
          4.ຮ້ານຄ້າຕ້ອງເປິດຊ່ອງທາງສີຂຽວໃຫ້ GoLaos ໂດຍສະເພາະແມ່ນ: ພາຍຫຼັງຮ້ານຄ້າໄດ້ຮັບອໍເດີຈາກຜູ້ໃຊ້ບໍລິການໃນ GoLaos ແລ້ວ, ຮ້ານຄ້າຕ້ອງໃຫ້ຄວາມສຳຄັນຂອງອໍເດີຜູ້ນຳໃຊ້ GoLaos ແລະ ຮັບຜິດຊອບສົ່ງສິນຄ້າໃຫ້ຜູ້ສັ່ງຊື້ຕາມຂໍ້ມູນທີ່ລະບຸໄວ້ໃນໃບອໍເດີໃຫ້ເໝາະສົມຕາມເວລາ,ການສົ່ງສິນຄ້າຕ້ອງມີການຫຸ້ມຫໍ່ແບບສົມເຫດສົມຜົນ,ຮັບປະກັນສິນຄ້າທີ່ສົ່ງໃຫ້ຜູ້ໃຊ້ບໍລິການຂອງ GoLaos ໄດ້ຄຸນນະພາບ ຫຼື ບໍໍ່ມີມົນລະພິດ ແລະ ທັນຕາມເວລາ.
        </div>
        <div class="letter letter1">
          5.ຫ້າມທາງຮ້ານຄ້າເກັບເງິນເພີ່ມຈາກລາຄາທີ່ກໍານົດໄວ້ນໍາຜູ້ໃຊ້ບໍລິການຂອງ GoLaos, ຖ້າຫາກສິນຄ້າທີ່ຜູ້ໃຊ້ບໍລິການໄດ້ສັ່ງຊື້ແມ່ນໝົດແລ້ວ, ທາງຮ້ານຄ້າສາມາດປຶກສາຫາກັບຜູ້ໃຊ້ບໍລິການໄດ້ເພື່ອປ່ຽນເປັນສິນຄ້າອື່ນ ແລະ ເກັບເງິນສ່ວນເກີນຕາມລາຄາສິນຄ້າ, ແຕ່ຕ້ອງຢູ່ບົນພື້ນຖານທີ່ໃຫ້ທາງຮ້ານຄ້າ ແລະ ຜູ້ໃຊ້ບໍລິການຂອງ GoLaos ຕົກລົງເຫັນດີເປັນເອກະພາບກັນ.
        </div>
        <div class="letter letter1">
          6.ຖ້າຫາກຜູ້ໃຊ້ບໍລິການມີຄວາມຕ້ອງການຈະເອົາໃບບິນ, ໃຫ້ຮ້ານຄ້າເປັນຜູ້ສະໜອງໃຫ້, ພາຍຫຼັງGoLaos ໄດ້ແຈ້ງຂໍ້ມູນກ່ຽວກັບອໍເດີຂອງຜູ້ໃຊ້ບໍລິການໃຫ້ຮ້ານຄ້າແລ້ວ, ຖ້າຫາກສິນຄ້າທີ່ຖືກສັ່ງ ບໍ່ພໍ ຫຼື ບໍ່ສາມາດສະໜອງໃຫ້ໄດ້ັນ້ນ, ທາງຮ້ານຄ້າຕ້ອງໂທແຈ້ງໃຫ້ຜູ້ໃຊ້ບໍລິການ ແລະ GoLaos ຮັບຮູ້ໂດຍທັນທີ, ພ້ອມນໍາມາດຕະການແກ້ໄຂ ແລະ ປອບໃຈຜູ້ໃຊ້ບໍລິການ, ຖ້າຫາກຍ້ອນເຫດຜົນດັ່ງກ່າວເຮັດໃຫ້ GoLaosຖືກຜູ້ນໍາໃຊ້ບໍລິການຮ້ອງຟ້ອງ ຫຼື ຮ້ອງທຸກ ເຮັດໃຫ້ມີຜົນເສຍຫາຍທາງດ້ານເສດຖະກິດນັ້ນ, ໃຫ້ທາງຮ້ານຄ້າເປັນຜູ້ຮັບຜິດຊອບທັງໝົດ.
        </div>
        <div class="letter letter1">
          7.ຮ້ານຄ້າຕ້ອງມີສ່ວນຫຼູດ ຫຼື ຂອງແຖມໃຫ້ຜູ້ໃຊ້ບໍລິການ GoLaos ຕາມແຜນກິດຈະກໍາຂອງທັງສອງຝ່າຍໄດ້ຕົກລົງໄວ້, ຫ້າມບໍ່ໃຫ້ມີການກະທໍາທີ່ບໍ່ໃຫ້ຜູ້ນຳໃຊ້ບໍລິການໂດຍເຈດຕະນາ, ຖ້າບໍ່ດັ່ງນັ້ນ, ຄວາມເສຍຫາຍທັງໝົດທີ່ເກີດຂຶ້ນຈາກການຮ້ອງຟ້ອງ ຫຼື ຮຽກຮ້ອງສິດຂອງຜູ້ໃຊ້ບໍລິການນັ້ນແມ່ນໃຫ້ທາງຮ້ານຄ້າເປັນຜູ້ໃຊ້ແທນທັງໝົດ.
        </div>
        <div class="letter letter1">
          8.ທາງຮ້ານຄ້າຕ້ອງໃຫ້ຄໍາໝັ້ນສັນຍາວ່າ: ໃນໄລຍະການນໍາໃຊ້ GoLaos ຕົນເອງຈະບໍ່ກະທໍາສີ່ງທີ່ຜິດລະບຽບກົດໝາຍຄືດັ່ງລຸ່ມນີ້, ຖ້າຫາກມີກໍລະນີຄືດັ່ງລຸ່ມນີ້ເກີດຂຶ້ນ, ເຮັດໃຫ້ມີຜົນເສຍຫາຍນັ້ນ, ທາງຮ້ານຄ້າຈະເປັນຜູ້ຮັບຜິດຊອບຄວາມເສຍຫາຍທັງໝົດ ແລະ ຮັບຜິດຊອບຕາມລະບຽບກົດໝາຍ.
        </div>
        <div class="letter letter1">
          9.ລະເມີດຂໍ້ກຳນົດຂອງກົດໝາຍ, ລ່ວງລະເມີດຜົນປະໂຫຍດສາທາລະນະສັງຄົມ ແລະ ສິນລະທໍາຂອງປະຊາຊົນ.
        </div>
        <div class="letter letter1">
          10.ມີການກະທໍາມີລະເມີດກົດລະບຽບຕ່າງໆຂອງ GoLaos (ລວມທັງບໍ່ຈໍາກັດສະເພາະແຕ່ປອມແປງອໍເດີ, ນໍາໃຊ້ຈຸດພົກພ່ອງຂອງລະບົບຫາຜົນປະໂຫຍດສ່ວນຕົວ, ຖອນເງິນສົດແບບຜິດລະບຽບ,ສໍ້ໂກງເງິນຂອງຜູ້ໃຊ້ບໍລິການ, ຍົກເລີກອໍເດີໂດຍບໍ່ມີເຫດຜົນ, ບໍ່ສົ່ງສິນຄ້າ ຫຼື ປະຕິເສດໂດຍບໍ່ມີເຫດຜົນຕ່າງໆ).
        </div>
        <div class="letter letter1">
          11.ມີພຶດຕິກໍາອື່ນທີ່ສ້າງຄວາມເສຍຫາຍໃຫ້ແກ່ແພຣດຟອມ GoLaos, ຜູ້ໃຊ້ບໍລິການ ແລະ ຮ້ານຄ້າອື່ນນັ້ນ.
        </div>
        <div class="letter letter1">
          12.ຮ້ານຄ້າສາມາດເຂົ້າລະບົບແພຣດຟອມGoLaos ໄດ້ໂດຍຜ່ານບັນຊີ ແລະ ລະຫັດຜ່ານຂອງຕົນ, ຮ້ານຄ້າຕ້ອງຮັບຜິດຊອບຕໍ່ຄວາມປອດໄພຂອງລະຫັດຜ່ານ ແລະ ການກະທໍາຂອງຕົນ, ຫ້າມຮ້ານຄ້າມອບໂອນບັນຊີ ແລະ ລະຫັດຜ່ານໃຫ້ຝ່າຍທີ່ສາມ ຫຼື ເປີດເຜີຍໃຫ້ຜູ້ອື່ນຮູ້, ບໍ່ວ່າເປັນຮູບແບບໃດກໍ່ຕາມ.
        </div>
        <div class="letter letter1">
          13.ຂໍ້ມູນກ່ຽວກັບບັນຊີທະນາຄານທີ່ຮ້ານຄ້າໄດ້ສະໜອງໃຫ້ນັ້ນ ຕ້ອງຖືກຕ້ອງ ແລະ ນໍາໃຊ້ປົກກະຕິ, ຖ້າຫາກມີການປ່ຽນຂໍ້ມູນຕ້ອງແຈ້ງໃຫ້ GoLaos ຮັບຮູ້ໂດຍທັນທີ. ຖ້າບໍ່ດັ່ງນັ້ນ, ການຊໍາລະເງິນຊັກຊ້າ ຫຼື ຜົນກະທົບອື່ນໆທີ່ເກີດຂຶ້ນ ໃຫ້ທາງຮ້ານຄ້າເປັນຜູ້ຮັບຜິດຊອບ.
        </div>
        <div class="letter letter1">
          14.ຮ້ານຄ້າຮັບຕ້ອງປະກັນວ່າລາຄາສິນຄ້າທີ່ໄດ້ຂາຍຕົວຈິງບໍ່ໃຫ້ຕໍ່າກວ່າລາຄາທີ່ວາງອອກໃນເເພຣດຟອມ GoLaos,ຫ້າມບໍໍ່ໃຫ້ມີການກະທໍາເຊື່ອມເສຍ ຫຼື ແນະນໍາໃຫ້ຜູ້ໃຊ້ບໍລິການຂອງ GoLaos ຍົກເລີກການນໍາໃຊ້ບໍລິການຂອງ GoLaos, ຫຼື ປ່ຽນແປງຮູບແບບຂອງຮ້ານຄ້າດໍາເນີນການຄ້າຂາຍນໍາ GoLaosໂດຍກົງ; ຖ້າບໍ່ດັ່ງນັ້ນ, GoLaos ມີສິດຍົກເລີກສັນຍາໂດຍທັນທີ ພ້ອມຮຽກຮ້ອງໃຫ້ຮ້ານຄ້າຮັບຜິດຊອບຄວາມເສຍຫາຍທັງໝົດຕາມຂໍ້ກໍານົດຂອງມາດຕາ6.
        </div>
        <div class="letter letter1">
          15.ທາງຮ້ານຄ້າຕ້ອງຕົກລົງເຫັນດີໃຫ້ GoLaos ຮ່ວມມືກັບບຸກຄົນສາມເພື່ອສະໜອງການບໍລິການທາງດ້ານເຄືອຂ່າຍທີ່ກ່ຽວຂ້ອງໃຫ້ຮ້ານຄ້າ, ໃນກໍລະນີນີ້, ຖ້າບຸກຄົນທີ່ສາມນັ້ນຕົກລົງເຫັນດີຈະປະຕິບັດ ຫຼື ຮັບຜິດຊອບຕໍ່ຂໍ້ມູນສ່ວນຕົວຂອງຜູ້ນໍາໃຊ້ບໍລິການຄືກັນກັບ GoLaos. GoLaos ມີສິດສະໜອງຂໍ້ມູນສ່ວນຕົວຂອງຜູ້ນໍາໃຊ້ບໍລິການໃຫ້ແກ່ບຸກຄົນທີ່ສາມ. ນອກຈາກນີ້, GoLaos ມີສິດວິເຄາະ ຫຼື ສືກສາຖານຂໍ້ມູນຂອງຜູ້ນໍາໃຊ້ບໍລິການ ແລະ ນໍາໃຊ້ເຂົ້າໃນທາງດ້ານທຸລະກິດໂດຍບົນພື້ນຖານທີ່ເປັນຄວາມລັບ ຫຼື ຂໍ້ມູນສ່ວນຕົວຂອງຮ້ານຄ້າ.
        </div>
        <div class="letter letter1">
          16.ຮ້ານຄ້າຕ້ອງຕົກລົງເຫັນດີໃຫ້ GoLaos ມີສິດສົ່ງແຈ້ງການ ຫຼື ຂໍ້ມູນອື່ນໂດຍຜ່ານຮູບແບບໃນເເພຣດຟອມ GoLaos, ຂໍ້ຄວາມ, ໂທລະສັບ ແລະ ອິເມວຕ່າງໆ. ຮ້ານຄ້າຕ້ອງຕົກລົງເຫັນດີໃຫ້ເເພຣດຟອມ GoLaos ສົ່ງຂໍ້ມູນ ຫຼື ຂ່າວຕ່າງໆທີ່ກ່ຽວກັບທຸລະກິດໃຫ້ຕົນເອງ.
        </div>
        <h3>ມາດຕາ 04 : ສິດ ແລະ ພັນທະຂອງ GoLaos</h3>
        <div class="letter1 letter">
          1.GoLaos ໃຫ້ຮ້ານຄ້າ ສະເເດງຜົນ online ໂດຍອີງໃສ່ ການເຫັນດີຕົກລົງຂອງຂໍ້ກຳນົດ ແລະ ເກັບຄ່າບໍລິການນໍາຮ້ານຄ້າຕາມຂໍ້ຕົກລົງຂອງ ແພຣດຟອມ GoLaos.
        </div>
        <div class="letter1 letter">
          2.GoLaos ຕ້ອງແນະນໍາ ແລະ ໂຄສະນາໃຫ້ຮ້ານຄ້າໃນກຸ່ມວົງການບໍລິໂພກ, ເພື່ອຍົກສູງຊື່ສຽງຂອງຮ້ານຄ້າ, ຮ້ານຄ້າຕົກລົງເຫັນດີມອບສິດໃຫ້ GoLaos ນໍາໃຊ້ຍີ່ຫໍ້, LOGO, ຊື່ຮ້ານຄ້າ, ເຄື່ອງໝາຍສິນຄ້າ ແລະ ຊັບສິນທາງປັນຍາຕ່າງໆຂອງຕົນເອງ.
        </div>
        <div class="letter letter1">
          3.GoLaos ມີສິດກວດກາ, ພິຈາລະນາຮັບຮອງຂໍ້ມູນຂ່າວສານທີ່ຈະເຜີຍແຜ່ ຫຼື ໂພດຣລົງໃນ GoLaos, ມີສິດດັດແກ້ ແລະ ລົບອອກຂໍ້ມູນຂ່າວສານໃນເວລາທີ່ຈໍາເປັນ, GoLaos ມີສິດພິຈາລະນາຮັບຮອງ ຫຼື ລົບເນື້ອໃນທີ່ຜິດລະບຽບກົດໝາຍ, ຜິດກັບກົດລະບຽບ ຫຼື ເປັນເນື້ອໃນທີ່ລ່ວງລະເມີດສິດຂອງບຸກຄົນທີ່ສາມ. ແຕ່ທັງສອງຝ່າຍຢຶນຢັນວ່າ, ວຽກການກວດສອບ ແລະ ການພິຈາລະນາຮັບຮອງ ແລະ ການລົບອອກຂໍ້ມູນຕ່າງໆ ຂອງ GoLaos ບໍ່ໄດ້ມີຂໍ້ກຳນົດພັນທະໃດໆສຳລັບ GoLaos,ແລະ ບໍ່ໄດ້ຍົກເວັ້ນຜູ້ຮັບຜິດຊອບຕາມຂໍ້ກຳນົດຂອງສັນຍາສະບັບນີ້.
        </div>
        <div class="letter1 letter">
          4.ຖ້າບຸກຄົນທີ່ສາມຮ້ອງທຸກຕໍ່ GoLaos, ຫຼັງຈາກກວດສອບແລ້ວ, GoLaos ມີສິດຮ້ອງຂໍໃຫ້ຮ້ານຄ້າໃຫ້ຄວາມຮ່ວມມືໃນການແກ້ໄຂຄໍາຮ້ອງທຸກດັ່ງກ່າວ, ຖ້າຫາກມີເນື້ອໃນທີ່ຜິດລະບຽບກົດໝາຍ, ກົດລະບຽບ, ນະໂຍບາຍ ຫຼື ລະເມີດສິດທິທາງກົດໝາຍຂອງບຸກຄົນທີ່ສາມນັ້ນ, GoLaos ມີສິດປຶກສາຫາລື ແລະ ແກ້ໄຂກັບຜູ້ໃຊ້ບໍລິການໂດຍບໍ່ແຈ້ງໃຫ້ຮ້ານຄ້າຮັບຮູ້.
        </div>
        <div class="letter1 letter">
          5.ຖ້າຫາກສິນຄ້າທີ່ລົງຂາຍໃນຮ້ານຄ້າລະເມີດກົດລະບຽບທີ່ກ່ຽວຂ້ອງໃນຂອບເຂດທຸລະກິດຂອງແພຣດຟອມ GoLaos ຫຼື ມີການຂາຍສິນຄ້າທີ່ຫວງຫ້າມໃຫ້ຜູ້ຊື້ແບບສ່ວນຕົວ, GoLaos ມີສິດລົງໂທດຜູ້ຄ້າຂາຍ ໂດຍອີງຕາມການກໍານົດຂອງລະບຽບກົດໝາຍຕ່າງໆ, ພ້ອມມອບໃຫ້ພາກສ່ວນທີ່ກ່ຽວຂ້ອງເພື່ອດໍາເນີນກົດໝາຍຂອງ ສປປ ລາວ.
        </div>
        <div class="letter1 letter">
          6.ຖ້າມີແຜນກິດຈະກຳກ່ຽວຂ້ອງກັບຄວາມຮັບຜິດຊອບຂອງ GoLaos ສຳລັບຕົ້ນທືນ ແລະ ຄ່າໃຊ້ຈ່າຍທີ່ກ່ຽວຂ້ອງ Lao life ຈະຈ່າຍຄ່າໃຊ້ຈາ່ຍໃນກິດຈະກຳໂດຍລະບົບ Lao life. ແລະ ຈະນໍາໃຊ້ວິທີການສະຫຼຸບ ແລະ ວິທີການຄິດໄລ່ຕາມຂໍ້ກໍານົດຂອງສັນຍາທີ່ທັງສອງຝ່າຍໄດ້ຕົກລົງກັນ.
        </div>
        <div class="letter1 letter">
          7.ກໍລະນີວ່າມີຜູ້ໃຊ້ບໍລີການຍົກເລີກໃບສັ່ງຈອງນັ້ນ, ພາຍຫຼັງ GoLaos ໄດ້ຮັບຄໍາເໜີຂໍຍົກເລີກແລ້ວ, GoLaos ຈະແຈ້ງຕໍ່ໃຫ້ຮ້ານຄ້າເພື່ອຍົກເລີກລາຍການ, ທາງຮ້ານຄ້າຕ້ອງມີການປ່ຽນແປງຕາມແຈ້ງການຂອງ GoLaos;
        </div>
        <div class="letter1 letter">
          8.ຖ້າຫາກທາງຮ້ານຄ້າໄດ້ລະເມີດມາດຕາ 03 ຂອງສັນຍາສະບັບນີ້, GoLaos ມີສິດຢຸດການສະໜອງບໍລິການໄດ້ທຸກເວລາ, ພ້ອມເອົາຂໍ້ມູນຂອງຮ້ານຄ້າດັ່ງກ່າວອອກຈາກ ແພຣດຟອມ GoLaos.
        </div>
        <div class="letter1 letter">
          9.ໃນເມື່ອສັນຍາສະບັບນີ້ໄດ້ສິ້ນສຸດລົງ, GoLaos ມີສິດລົບຂໍ້ມູນທັງໝົດທີ່ກ່ຽວກັບຮ້ານຄ້າອອກ, ພ້ອມມີສິດປະຕິເສດສະໜອງຂໍ້ມູນທີ່ກ່ຽວຂ້ອງໃຫ້ຮ້ານຄ້າ, GoLaos ມີສິດຮັກສາຂໍ້ມູນຂອງຮ້ານຄ້າ, ຂໍ້ມູນຂອງສິນຄ້າ ແລະ ປະຫວັດການເຄື່ອວໄຫວຕ່າງໆໄວ້.
        </div>
        <h3>
          ມາດຕາ 05 : ຊັບສິນທາງປັນຍາ
        </h3>
        <div class="letter letter1">
          1.ຍີ່ຫໍ້ແມ່ນຕ້ອງໃຊ້ຂອງໃຜຂອງມັນ, ກ່ອນບໍ່ໄດ້ຮັບນຸຍາດ ຫຼື ກ່ອນບໍ່ໄດ້ຮັບການມອບສິດ,ຫ້າມຝ່າຍໃດຝ່າຍໜຶ່ງນໍາໃຊ້ຊື່, LOGO, ອຸປະກອນການໂຄສະນາ, ຂໍ້ມູນທີ່ກ່ຽວກັບການຂາຍ, ກິດຈະກໍາສ່ວນຫຼຸດ,ການໂຄສະນາ, ວາລະສານ,ໜັງສືພິມ ແລະ ພິມເປັນເຈ້ຍໃບປີວຕ່າງໆ. ຖ້າຫາກບໍ່ປະຕິບັດຕາມການກໍານົດນີ້, ເຮັດໃຫ້ມີຜົນກະທົບທີ່ບໍ່ດີ ຫຼື ມີຜົນເສຍຫາຍທາງດ້ານເສດຖະກິດ,ຝ່າຍລະເມີດສັນຍາເປັນຜູ້ຮັບຜິດຊອບທັງໝົດ. ຍົກເວັ້ນຕາມທີ່ໄດ້ກຳນົດໄວ້ໃນມາດຕາ4.2 ຂອງສັນຍາສະບັບນີ້.
        </div>
        <h3>ມາດຕາ 06 : ການຮັບປະກັນຄວາມປອດໄພຂອງເຄື່ອງກີນ</h3>
        <div class="letter letter1">
          1.ໃບທະບຽນ ແລະ ໃບອະນຸຍາດຕ່າງໆ ທີ່ຮ້ານຄ້າໄດ້ສະໜອງໃຫ້ໂດຍຜູ້ຂາຍຕ້ອງປະຕິບັດຕາມລະບຽບກົດໝາຍ ແລະ ຖືກຕ້ອງຕາມຂໍ້ກຳນົດທີ່ກ່ຽວກັບການເຜີຍແຜ່ຜະລິດຕະພັນທີ່ກ່ຽວຂ້ອງ. , ໃນເວລາແພຣດຟອມ GoLaos ຕ້ອງການໃຫ້ສະໜອງຂໍ້ມູນນັ້ນ, ຮ້ານຄ້າຕ້ອງສະໜອງເອກະສານທີ່ກ່ຽວຂ້ອງພາຍໃນ 24 ຊົ່ວໂມງ, ຖ້າຫາກຍ້ອນທາງຮ້ານຄ້າບໍ່ສາມາດສະໜອງເອກະສານໃຫ້ໄດ້, ເຮັດໃຫ້ເວທີ GoLaos ມີຄວາມເສຍຫາຍນັ້ນ, ທາງຮ້ານຄ້າຕ້ອງຮັບຜິດຊອບຕໍ່ຄວາມເສຍຫາຍທີ່ເກີດຂຶ້ນ.
        </div>
        <div class="letter letter1">
          2.ສິນຄ້າທີ່ທາງຮ້ານຄ້າໄດ້ສະໜອງນັ້ນຕ້ອງໄດ້ມາດຕະຖານ, ຖືກຕ້ອງຕາມລະບຽບກົດໝາຍ, ຖ້າຫາກຍ້ອນຄຸນນະພາບຂອງສິນຄ້າ ຫຼື ຍ້ອນສິນຄ້າດັ່ງກ່າວບໍ່ມີຄວາມປອດໄພເຮັດໃຫ້ຜູ້ໃຊ້ບໍລິການ GoLaos ຮ້ອງທຸກ, ຮຽກຮ້ອງໃຫ້ທົດແທນຄ່າເສຍຫາຍຕ່າງໆນັ້ນ, ມອບໃຫ້ທາງຮ້ານຄ້າເປັນຜູ້ຮັບຜິດຊອບທັງໝົດ. ໃນກໍລະນິ GoLaos ໄດ້ໃຊ້ແທນໃຫ້ຜູ້ບໍລິການກ່ອນຕາມເງື່ອນໄຂ, GoLaosມີສິດຮຽກຮ້ອງໃຫ້ຮ້ານຄ້າຈ່າຍຄືນໃຫ້,ວິທີການຊໍາລະເງິນຄືນລວມທັງບໍ່ຈໍາກັດສະເພາະແຕ່ຫັກເງິນຈໍານວນດັ່ງກ່າວອອກຈາກເງິນທີ່ຕ້ອງຈ່າຍໃຫ້ຮ້ານຄ້າ;
        </div>
        <h3>ມາດຕາ 07 : ຄວາມຮັບຜິດຊອບຕໍ່ການລະເມີດສັນຍາ</h3>
        <div class="letter letter1">
          1.ຖ້າຫາກຝ່າຍໃດຝ່າຍໜຶ່ງລະເມີດສັນຍາສະບັບນີ້, ເຮັດໃຫ້ອີກຝ່າຍໜຶ່ງໄດ້ຮັບຜົນກະທົບ ແລະ ມີຄວາມເສຍຫາຍ, ລວມທັງບໍ່ຈໍາກັດສະເພາະແຕ່ຖືກຮ້ອງທຸກ, ແຈ້ງຟ້ອງ, ດໍາເນີນຄະດີ, ປັບໃໝ ຫຼື ທົດແທນຄວາມເສຍຫາຍຕ່າງໆ, ຝ່າຍລະເມີດສັນຍາຕ້ອງຢຸດຕິການກະທໍາລະເມີດນັບແຕ່ມື້ໄດ້ຮັບໜັງສືຈາກຝ່າຍປະຕິບັດສັນຍາເປັນຕົ້ນໄປ, ພ້ອມໃຫ້ທົດແທນຄ່າເສຍຫາຍທັງໝົດທີ່ເກີດຂຶ້ນໃຫ້ຝ່າຍທີ່ບໍ່ໄດ້ລະເມີດພາຍໃນ 10 ວັນ.
        </div>
        <div class="letter letter1">
          2.ທຸກຝ່າຍຕ້ອງຮັກສາປົກປິດບັນດາເອກະສານ ແລະ ຂໍ້ມູນທີ່ກ່ຽວກັບການດໍາເນີນທຸລະກິດໃຫ້ເປັນຄວາມລັບ, ແຜນວຽກ, ການເງິນ ແລະ ຂໍ້ມູນອື່ນທີ່ກ່ຽວຂ້ອງ, ຫ້າມບໍ່ໃຫ້ສະໜອງ ຫຼື ເປີດເຜີຍຕໍ່ບຸກຄົນທີ່ສາມ. ຖ້າຫາກຝ່າຍໃດຝ່າຍໜຶ່ງບໍ່ປະຕິບັດຕາມຂໍ້ກໍານົດນີ້, ເຮັດໃຫ້ອີກຝ່າຍໃດໜຶ່ງ ຫຼື ຜູ້ອື່ນໄດ້ຮັບຜົນກະທົບ ແລະ ມີຄວາມເສຍຫາຍ, ຝ່າຍລະເມີດຕ້ອງຮັບຜິດຊອບທົດແທນຄວາມເສຍຫາຍທັງໝົດທີ່ເກີດຂຶ້ນ.
        </div>
        <h3>ມາດຕາ 08 : ຂໍ້ກໍານົດກ່ຽວກັບການຍົກເວ້ັນຄວາມຮັບຜິດຊອບ</h3>
        <div class="letter letter1">
          1.ບໍ່ວ່າຈະເປັນກໍລະນີໃດກໍ່ຕາມ, GoLaos ຈະບໍ່ຮັບຜິດຊອບຄວາມເສຍຫາຍທີ່ເກີດຂຶ້ນຈາກການສ້ອມແປງອິນເຕີເນັດ,ບັນຫາການເຊື່ອມຕໍ່ອິນເຕີເນັດ, ບັນຫາຂອງຄອມພິວເຕີ ຫຼື ລະບົບໂທລະຄົມ, ບັນຫາລະບົບໄຟຟ້າ, ການໂຈມຕີຂອງແຮັກເກີ, ໄວຣັດເຂົ້າ, ການປະທ້ວງ,ຂໍ້ຂັດແຍ່ງດ້ານແຮງງານ, ການກະບົດ,ການກໍ່ການຮ້າຍ, ວິກິດການ, ກໍາລັງ ຫຼື ວັດຖຸການຜະລິດບໍ່ພຽງພໍ, ອະຄີໄພ, ໄພນໍ້າຖ້ວມພາຍຸ, ການລະເບີດ, ສົງຄາມ, ລັດຖະປະຫານ ຫຼື ມີຄໍາສັ່ງຈາກຂະແໜງຍຸດຕິທໍາ ຫຼື ຍ້ອນເຫດຜົນຂອງບຸກຄົນທີ່ສາມ,ເຮັດໃຫ້ການບໍລິການຊັກຊ້າຕ່າງໆ.
        </div>
        <div class="letter letter1">
          2.ຮ້ານຄ້າຕົກລົງເຫັນດີຈະຮັບຜິດຊອບຄວາມສ່ຽງໃນດ້ານເຄືອຂ່າຍຂອງຕົນເອງ, GoLaos ຈະບໍ່ຄໍ້າປະກັນ ຫຼື ຮັບປະກັນໃດໆ, ໂດຍສະເພາະແມ່ນ: ບໍ່ຮັບປະກັນວ່າການບໍລິການຕ້ອງຖືກໃຈຕາມຄວາມຕ້ອງການຂອງຮ້ານຄ້າ, ບໍ່ຮັບປະກັນວ່າການບໍລິການຈະບໍ່ຕິດຄັດ, ບໍ່ຮັບປະກັນຕໍ່ຄວາມປອດໄພ, ທັນເວລາ ແລະ ຄວາມຜິດພາດ, ບໍ່ຄໍ້າປະກັນຕໍ່ທຸກຝ່າຍໃນການຮ່ວມມືລະຫວ່າງ GoLaos ແລະ ບຸກຄົນທີ່ສາມ; ບໍ່ຮັບປະກັນ ຫຼື ຄໍ້າປະກັນ, ຄວາມຖືກຕ້ອງ, ຄວາມເຊື່ອໝັ້ນ, ຄວາມໝັ້ນຄົງ, ທັນຕາມເວລາ, ບໍ່ຮັບປະກັນວ່າການບໍລິການຂອງ GoLaos ຈະບໍ່ເກີດຄວາມຜິດພາດ ແລະ ຄວາມພົກພ່ອງ.
        </div>
        <h3>ມາດຕາ 09: ການແກ້ໄຂຂໍ້ຂັດແຍ່ງ</h3>
        <div class="letter letter1">
          1.ສັນຍາສະບັບນີ້ຖືກຄວບຄຸມໂດຍກົດໝາຍແຫ່ງ ສປປ ລາວ, ການເຮັດສັນຍາ, ການປະຕິບັດ ການຕີຄວາມໝາຍ ແລະ ການແກ້ໄຂຂໍ້ຂັດແຍ່ງຕ່າງໆໃຫ້ອີງໃສ່ລະບຽບກົດໝາຍ ສປປ ລາວ ທັງໝົດ.
        </div>
        <div class="letter letter1">
          2.ຖ້າຫາກມີຂໍ້ຂັດແຍ່ງເກີດຂຶ້ນໃນໄລຍະການປະຕິບັດສັນຍາສະບັບນີ້, ທັງສອງຝ່າຍຕົກລົງເຫັນດີຈະປຶກສາຫາລືກັນໂດຍສັນຕິວິທີກ່ອນ, ຜ່ານການປຶກສາຫາລືກັນແລ້ວຍັງແກ້ໄຂບໍ່ໄດ້, ຈະມອບໃຫ້ພາກສ່ວນທີ່ກ່ຽວຂ້ອງດໍາເນີນຕາມລະບຽບກົດໝາຍຂອງ ສປປ ລາວ.
        </div>
      </div>
    </my-scroll>
  </div>
</template>

<script>

import MyScroll from '../../components/MyScroll'
export default {
  name: 'newLifeZh',
  components: {
    MyScroll
  },
  setup () {
    // const { ctx } = getCurrentInstance()
    // console.log(ctx.$root.$route.query.lang)
    return {
      txt1: ''
    }
  }
}
</script>

<style scoped lang="scss">
@mixin flex-box-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-life {
  width: 100%;
  .scroll {
    width: 100%;
    height: 100%;
    padding: 0px 16px;
    position: absolute;
    touch-action: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 0px;
    }
    header {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 35px;
      height: 28px;
      padding: 0px 16px;
      overflow: hidden;
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
      font-family: Phetsarath OT;
      color: #333333;
      @include flex-box-center;
    }
    .scroll-content {
      position: absolute;
      top: 0px;
      padding: 0px 16px;
      left: 0px;
      h3 {
        padding: 13px 0px 0px;
        margin-bottom: 12px;
        // height: 25px;
        opacity: 1;
        font-size: 15px;
        font-weight: bold;
        font-family: Phetsarath OT;
        text-align: left;
        color: #333333;
        // line-height: 40px;
      }
      span {
        // font-weight: 600;
      }
      .letter {
        text-align: left;
        opacity: 1;
        font-size: 15px;
        font-weight: 400;
        font-family: Phetsarath OT;
        line-height: 25px;
        // word-break: keep-all;
        color: #333333;
      }
      .letter1 {
        margin-top: 12px;
      }
    }
  }
}
</style>
